import { render, staticRenderFns } from "./CompassArrow.vue?vue&type=template&id=5b5b5a72&"
import script from "./CompassArrow.vue?vue&type=script&lang=js&"
export * from "./CompassArrow.vue?vue&type=script&lang=js&"
import style0 from "./CompassArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kristiankalva/Local Sites/ensign-boligprosjekter/app/public/wp-content/plugins/ensign-boligprosjekter/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b5b5a72')) {
      api.createRecord('5b5b5a72', component.options)
    } else {
      api.reload('5b5b5a72', component.options)
    }
    module.hot.accept("./CompassArrow.vue?vue&type=template&id=5b5b5a72&", function () {
      api.rerender('5b5b5a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CompassArrow.vue"
export default component.exports